import { autoinject, useView } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { MobileHelper } from "../../../../../../helpers/mobile-helper";
import { DialogServiceConstants } from "../../../../../../constants/basics/dialog.constants";

@autoinject
@useView('views/plugins/onboarding-requests/generic-plugin/landing-pages/default/master-page.html')
export class MasterPage {

    model: any;
    public isMobile = MobileHelper.isMobileDevice();

    constructor(private dialogClientService: DialogClientService) { }

    activate(model: any) {
        if(model.step) {
            this.model = model;
            const folder = this.model.step.onboardingSession._completeRequestLandingPage == "complete-request-pages" ? "complete-request-pages" : "expired-request-pages";

            require(model.step.onboardingSession._onboardingRequestsPath +'/'+ model.step.onboardingSession._pluginName +'/landing-pages/default/'+ folder +'/'+ model.step.onboardingSession._landingPage +'/'+ model.step.onboardingSession._landingPage +'.ts');
        }
    }

    continueFromMobile() {
        this.dialogClientService.show(DialogServiceConstants.URLs.ContinueFromMobileDialog, {}, false);
    }
}
